import { Component } from '@angular/core';
import { NavController, LoadingController, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as firebase from 'firebase';
import { ConfigurationServices } from '../services';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

@Component({
  selector: 'page-configuration-domains',
  templateUrl: 'configuration-domains.html'
})

export class ConfigurationDomainsPage {

  domini: any;
  dominiForm: any;
  firestore;

  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    private configurationServices: ConfigurationServices,
    public fb: FormBuilder,
    private toastCtrl: ToastController) {

    this.firestore = firebase.firestore();

    this.dominiForm = this.fb.group({
      domini: ['', [Validators.required, Validators.pattern("[a-z0-9.-]{1,}")]],
    });

    this.globals.GAtrackView('Configuration', 'Configuration - Domains - View', this.globals.restaurant.email, 'View', 'View Domains', 'Configuration', '');
  }

  ionViewDidEnter() {
    this.domini = this.globals.domini_sites;
  }

  async getDomini() {
    const publicKeyRef = this.firestore.collection('public_key');
    //Recuperem el domini del restaurant
    await publicKeyRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let data = doc.data();
          //Si tiene el addon pro cogemos el dominio
          if (this.globals.checkLimitsByLicense('sites', 'web_config')) {
            if (data.domini == undefined) {
              this.domini = doc.id;
            } else {
              this.domini = data.domini;
            }
          } else {
            this.domini = doc.id;
          }
        });
      });
  }

  async saveDomini() {
    //Modifiquem el domini del restaurant
    this.configurationServices.afs.collection('public_key').doc(this.globals.public_key).update({
      'domini': this.domini,
    }).then(() => {
      this.globals.GAtrackView('Configuration', 'Configuration - Domains - Update', this.globals.restaurant.email, 'Create/Update', 'Update domains', 'Configuration', this.domini);
    });
    this.globals.domini_sites = this.domini;
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-dominio-guardado'),
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  async check() {
    //Comprovamos limites de la licencia
    if (this.globals.checkLimitsByLicense('sites', 'web_config')) {
      if (!this.dominiForm.valid) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-acepta-minusculas-puntos-guiones'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
      } else {
        //Si checkDomini retorna falso, podemos crear el dominio para el restaurante. Si no es que ja existe el dominio
        let domini_exists = await this.checkDomini();
        if (!domini_exists) {
          this.saveDomini();
          //Enviamos un msg a slack
          var msg = this.translate.instant('general-dominio-configurado-de') + ' ' + this.globals.restaurant.email + ' ' + this.translate.instant('general-nombre-restaurante') + " " + this.globals.restaurant.company + '.';
          this.sendSlack(msg);
        } else {
          let toast = this.toastCtrl.create({
            message: this.translate.instant('general-este-domino-existe'),
            duration: 3000,
            position: 'top'
          });
          toast.present();
        }
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }


  async checkDomini() {
    const publicKeyRef = this.firestore.collection('public_key');
    let domini_exists = false;
    await publicKeyRef.where('domini', '==', this.domini)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          if (doc.data()) {
            domini_exists = true;
          }
        });
      });
    return domini_exists;
  }

  async sendSlack(msg) {
    await this.http.post(this.globals.api_path + 'slack/integrations', {
      msg: msg,
    }, {}).subscribe(async data => {
    },
      err => {
      }
    );
  }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-domains/configuration-domains.ts